import { TO_PAYMENT, TO_SHIPPING } from "./actions";

export function PhoneNumber(state = 'tel:+14144254069', action) {
  return state;
}

export function PhoneText(state = '(414) 425-4069', action) {
  return state;
}

export function completeCheckoutButtonText(state = '', action) {
  return state;
}

export function onPaymentScreen(state = false, action) {
  switch(action.type) {
    case TO_PAYMENT:
      return true;
    case TO_SHIPPING:
      return false;
  }
  return state;
}
